module.exports = __webpack_public_path__ + "static/p13_becerroCollar-d24f1885d6dd6042c542ca346407ecf5.png";